export default function initPresentationGallery() {
    const gallery = document.getElementById('presentationGallery');
    if (!gallery) return;

    // Wait for PhotoSwipeLightbox to be available (it's loaded via product-images-carousel.js)
    const initLightbox = () => {
        if (window.PhotoSwipeLightbox) {
            const lightbox = new window.PhotoSwipeLightbox({
                gallery: '#presentationGallery',
                pswpModule: () =>
                    import ('photoswipe'),
                bgOpacity: 1,
                showHideOpacity: true,
                children: 'a',
                loop: true,
                showHideAnimationType: 'zoom',
                imageClickAction: 'zoom',
                tapAction: 'zoom',
                mouseMovePan: true,
                initialZoomLevel: 'fit',
                secondaryZoomLevel: 1.5,
                maxZoomLevel: 1,
                zoom: true,
                close: true,
                counter: true,
                arrowKeys: true,
                wheelToZoom: true,
            });

            lightbox.init();
        } else {
            // Retry after a short delay if PhotoSwipeLightbox isn't loaded yet
            setTimeout(initLightbox, 100);
        }
    };

    initLightbox();
}
